import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StateDistrictDialogComponent } from '../state-district-dialog/state-district-dialog.component';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';
import { StateDistrictPopupComponent } from '../../../../manage-user/state-district-popup/state-district-popup.component';
import { SaveConfirmManageUserComponent } from '../save-confirm-manage-user/save-confirm-manage-user.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { ToastrService } from 'ngx-toastr';

interface mergedPermission {
  id: number;
  name: string;
  states: { state_name: string; districts: string[] }[];
  states_perm?: { state_name: string; districts: string[] }[];
  role_id?: any;
}

interface MergedSubview {
  key: number;
  permission: mergedPermission[];
  viewName: string;
  labelName: string;
  role_id: number;
  subview: MergedSubview[];
}
// interface processedSubview {
//   key: number;
//   permission: processedPermission[];
//   viewName: string;
//   labelName: string;
//   country: string;
//   level: number;
//   role_id: number;
//   status: string;
//   subview: Subview[];
// }
interface RoleIdMap {
  level: string,
  role_id: number,
  permission: string
}
@Component({
  selector: 'app-permission-viewer',
  standalone: true,
  imports: [
    CommonModule,
    MatFormField,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule
  ],
  templateUrl: './permission-viewer.component.html',
  styleUrl: './permission-viewer.component.scss'
})
export class PermissionViewerComponent implements OnInit {
  isMobileView: boolean = false;
  @Input() views: any[] = [];
  @Input() showLabel: { [key: number]: string } = {};
  @Output() permissionToogleOff = new EventEmitter<{ rowData: any }>();
  @Input() managerPermission: any = [];
  openViewKeys: Set<number> = new Set();

  isChecked: boolean = true;
  levels: any[] = [];
  uniqueLevel: any[] = [];
  stateData: any;
  role_id!: number;
  selectedLevel: { [key: string]: number } = {};
  constructor(
    private dialog: MatDialog,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
  ) { }
  roleIDMap: { [key: string]: RoleIdMap[] } = {
    "can_manage_super_user": [{ level: "SPECIAL LEVEL", role_id: 2, permission: "can_manage_super_user" }, { level: "STATE LEVEL", role_id: 3, permission: "can_manage_state_admin" }, { level: "DISTRICT LEVEL", role_id: 4, permission: "can_manage_district_admin" }, { level: "FIELD LEVEL", role_id: 5, permission: "can_manage_field_worker" }],
    "can_manage_state_admin": [{ level: "STATE LEVEL", role_id: 3, permission: "can_manage_state_admin" }],
    "can_manage_district_admin": [{ level: "DISTRICT LEVEL", role_id: 4, permission: "can_manage_district_admin" }],
    "can_manage_field_worker": [{ level: "FIELD LEVEL", role_id: 5, permission: "can_manage_field_worker" }]
  }


  permissionList: any[] = []
  ngOnInit(): void {
    this.permissionList = this.managerPermission;
  }

  onRoleChange(event: any) {
    // this.selectRole.setValue(event.value);
    // this.role_id = Number(this.selectRole.value);
  }
  onToggle(view: MergedSubview, perm: mergedPermission) {
    this.isChecked = !this.isChecked
  }
  toggleView(viewKey: number) {
    if (this.openViewKeys.has(viewKey)) {
      this.openViewKeys.delete(viewKey);
    } else {
      this.openViewKeys.clear();
      this.openViewKeys.add(viewKey);
    }
  }

  onClick(i: any) {
    let items = this.uniqueLevel[i];
    // this.selectRole.setValue(items.role_id);
    // this.role_id = items.role_id

    if (this.managerPermission["can_manage_super_user"]) {
      this.stateData = [];
    }
    else {
      let permissions = this.managerPermission[items.permission];
      this.stateData = permissions.reduce((acc: any, cur: any) => {
        const state = cur.state[0];
        if (state != null) {
          const existingState = acc.find((item: any) => item.state_name === state);
          if (existingState) {
            existingState.districts = [...new Set([...existingState.districts, ...cur.district])]
          } else {
            acc.push({
              state_name: state,
              districts: cur.district
            })
          }
        }
        return acc
      }, []);
    }
  }
  onDistrictClick(state: any) {
    // const dialogRef = this.dialog.open(StateDistrictPopupComponent, {
    //  data: state
    // });
  }

  isOpen(viewKey: number): boolean {
    return this.openViewKeys.has(viewKey);
  }

  // openStateDistrictDialog(view: MergedSubview, perm: mergedPermission, checkbox?: any): void {
  //   const level_key: string = `${perm.id}-${view.key}`;
  //   if (this.selectedLevel[level_key] == undefined) {
  //     this.toaster.error("Please select a role to add/remove areas");
  //   }
  //   else {
  //     this.onClick(this.selectedLevel[level_key]);
  //     view.role_id = this.role_id;
  //     perm.states_perm = this.stateData;
  //     const dialogRef = this.dialog.open(StateDistrictDialogComponent, {
  //       data: { view: view, perm: perm }
  //     });

  //     dialogRef.afterClosed().subscribe((result: any) => {
  //       if (result) {
  //         // let activeList:any[]=[];
  //         // let inActiveList:any[]=[];

  //         const newStateList = {
  //           state: result.state,
  //           district: result.district,
  //         }

  //         this.handleChangeStateDistrict(view, perm, newStateList, result.isAdded);
  //       }
  //       else {
  //         if (perm.states.length == 0 && checkbox) {
  //           checkbox.checked = false;
  //         }
  //       }
  //     });
  //   }
  // }

  // handleChangeStateDistrict(view: MergedSubview, permission: mergedPermission, activeList: any, isAdded: boolean) {
  //   const dialogRef = this.dialog.open(SaveConfirmManageUserComponent);

  //   dialogRef.afterClosed().subscribe((result: string) => {
  //     if (result === "Yes") {
  //       // permission.states=activeList;
  //       this.selectedLevel = {};
  //       this.changeStateDistrict.emit({ view, permission, activeList, isAdded });
  //     }
  //   });

  // }

  // handlePermissionToogleOff(view: MergedSubview, permission: mergedPermission) {
  //   this.selectedLevel = {};

  //   this.permissionToogleOff.emit({ view, permission });
  // }

  // handlePermissionToogle(event: Event, view: MergedSubview, permission: mergedPermission) {
  //   const checkbox = event.target as HTMLInputElement;
  //   const isChecked = checkbox.checked;
  //   view.role_id = this.role_id
  //   const level_key: string = `${permission.id}-${view.key}`;
  //   if (this.selectedLevel[level_key] == undefined) {
  //     this.toaster.error("Please select a role to add/remove areas");
  //     checkbox.checked = !checkbox.checked;
  //   } else {
  //     if (isChecked) {
  //       this.openStateDistrictDialog(view, permission, checkbox);
  //     }
  //     else {
  //       const dialogRef = this.dialog.open(SaveConfirmManageUserComponent);
  //       dialogRef.afterClosed().subscribe((result: string) => {
  //         if (result === "Yes") {
  //           this.selectedLevel = {};
  //           this.permissionToogleOff.emit({ view, permission });
  //         }
  //         else {
  //           checkbox.checked = true;
  //         }
  //       });
  //     }
  //   }
  // }

  handlePermissionToogle(event: any, rowData: any) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    const dialogRef = this.dialog.open(SaveConfirmManageUserComponent);
    dialogRef.afterClosed().subscribe((result: string) => {
      if (result === "Yes") {
        this.selectedLevel = {};
        this.permissionToogleOff.emit({ rowData });
      }
      else {
        checkbox.checked = true;
      }
    });
  }

  check_checked(event: Event): string {
    const target = event.target as HTMLInputElement;
    const newStatus = target.checked ? 'Active' : 'In-Active';
    return newStatus;
  }
}
